import React from "react";
import { Label } from "../Label";
import { concatStringFromClassesArrayList } from "../../Utils";

export interface Props {
  id: string;
  name?: string;
  value?: string;
  classes?: string;
  inputClasses?: string;
  checked?: boolean;
  disabled?: boolean;
  label: React.ComponentProps<typeof Label>;
  hideLabel?: boolean;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  attributes?: { [key: string]: string };
  dataTestId: string;
  index?: number;
}

export const CheckboxInput = (props: Props) => {
  const classList = {
    defaultClass: "ons-checkbox",
    optionalClasses: [
      props.classes ? props.classes : null,
      props.hideLabel ? "ons-checkbox--no-label" : "",
    ],
  };
  const className = concatStringFromClassesArrayList(classList);

  const inputClassList = {
    defaultClass: "ons-checkbox__input",
    optionalClasses: [props.inputClasses ? props.inputClasses : null],
  };
  const inputClassName = concatStringFromClassesArrayList(inputClassList);

  const labelClassList = {
    defaultClass: "ons-checkbox__label",
    optionalClasses: [props.label.classes ? props.label.classes : null],
  };
  const labelClassName = concatStringFromClassesArrayList(labelClassList);

  return (
    <span className={className} data-testid={props.dataTestId}>
      <input
        type="checkbox"
        id={props.id}
        className={inputClassName}
        {...(props.value ? { value: props.value } : {})}
        {...(props.disabled ? { disabled: true, "aria-disabled": "true" } : {})}
        {...(props.name ? { name: props.name } : {})}
        {...(props.checked ? { defaultChecked: true } : {})}
        {...(props.attributes
          ? Object.entries(props.attributes)
              .map(([attribute, value]) => ({ [attribute]: value }))
              .reduce((acc, attribute) => ({ ...acc, ...attribute }), {})
          : {})}
        onClick={(e) => props.onClick !== undefined && props.onClick(e)}
        onChange={(e) => props.onChange !== undefined && props.onChange(e)}
        data-testid={props.dataTestId + "-input"}
      />

      <Label
        id={props.id + "-label"}
        for={props.id}
        inputType="checkbox"
        text={props.label.text}
        classes={labelClassName}
        description={props.label.description}
        dataTestId={props.dataTestId}
      />
    </span>
  );
};
